import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const gameLinks = [
    { name: 'FIFA Online 4', path: '/fifa-online-4' },
    { name: 'Age of Empires', path: '/age-of-empires' },
    { name: 'Liên Minh Huyền Thoại', path: '/lien-minh-huyen-thoai' },
    { name: 'CS:GO', path: '/csgo' },
    { name: 'PUBG', path: '/pubg' }
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', url: 'https://facebook.com', label: 'Facebook' },
    { icon: 'ri-youtube-fill', url: 'https://youtube.com', label: 'YouTube' },
    { icon: 'ri-twitch-fill', url: 'https://twitch.tv', label: 'Twitch' },
    { icon: 'ri-discord-fill', url: 'https://discord.com', label: 'Discord' }
  ];

  return (
    <footer className="bg-gradient-to-br from-dark-bg via-dark-card to-dark-bg border-t border-dark-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 sm:gap-12">
          {/* Newsletter Section */}
          <div className="lg:col-span-5">
            <h3 className="font-exo font-black text-2xl sm:text-3xl lg:text-4xl bg-gradient-gaming bg-clip-text text-transparent mb-3 sm:mb-4">
              ĐĂNG KÝ NHẬN TIN
            </h3>
            <p className="text-gray-400 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">
              Cập nhật tin tức game mới nhất mỗi ngày, không bỏ lỡ bất kỳ thông tin nào về thế giới esports và game thủ Việt Nam
            </p>
            <form className="space-y-3 sm:space-y-4">
              <input
                type="email"
                placeholder="Email của bạn..."
                className="w-full h-12 sm:h-14 px-4 sm:px-5 bg-dark-border border border-dark-hover rounded-xl text-white placeholder-gray-500 outline-none focus:border-accent-cyan transition-colors text-sm sm:text-base"
              />
              <button
                type="submit"
                className="w-full sm:w-52 h-11 sm:h-12 bg-gradient-gaming text-white font-inter font-semibold rounded-full hover:scale-105 transition-transform flex items-center justify-center gap-2 whitespace-nowrap text-sm sm:text-base"
              >
                ĐĂNG KÝ NGAY
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-3">
            <h4 className="font-inter font-bold text-xs sm:text-sm tracking-wider text-gray-400 mb-4 sm:mb-6">
              DANH MỤC
            </h4>
            <ul className="space-y-3 sm:space-y-4">
              {gameLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white hover:text-accent-cyan transition-colors flex items-center gap-2 group text-sm sm:text-base"
                  >
                    <i className="ri-arrow-right-s-line text-accent-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-4">
            <h4 className="font-inter font-bold text-xs sm:text-sm tracking-wider text-gray-400 mb-4 sm:mb-6">
              LIÊN HỆ
            </h4>
            <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              <div className="flex items-center gap-3 text-gray-300 text-sm sm:text-base">
                <i className="ri-phone-line text-accent-cyan"></i>
                <span>Hotline: 1900 xxxx</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300 text-sm sm:text-base">
                <i className="ri-mail-line text-accent-cyan"></i>
                <a href="mailto:contact@gametv.asia" className="hover:text-accent-cyan transition-colors break-all">
                  contact@gametv.asia
                </a>
              </div>
            </div>

            <h4 className="font-inter font-bold text-xs sm:text-sm tracking-wider text-gray-400 mb-3 sm:mb-4">
              ĐỊA CHỈ
            </h4>
            <p className="text-gray-400 leading-relaxed text-sm sm:text-base">
              Tầng 10, Tòa nhà ABC<br />
              123 Đường Nguyễn Huệ, Quận 1, TP.HCM
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-dark-border flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
          {/* Social Links */}
          <div className="flex items-center gap-3 sm:gap-4 order-1 md:order-1">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.url}
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label={social.label}
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-dark-border rounded-full text-white hover:bg-gradient-gaming transition-all hover:scale-110"
              >
                <i className={social.icon}></i>
              </a>
            ))}
          </div>

          {/* Copyright */}
          <div className="text-gray-500 text-xs sm:text-sm text-center order-3 md:order-2">
            © {currentYear} GameTV.asia - All rights reserved
          </div>

          {/* Policy Links */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm order-2 md:order-3">
            <Link to="/chinh-sach-bao-mat" className="text-gray-500 hover:text-accent-blue underline transition-colors whitespace-nowrap">
              Chính sách bảo mật
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/dieu-khoan-su-dung" className="text-gray-500 hover:text-accent-blue underline transition-colors whitespace-nowrap">
              Điều khoản sử dụng
            </Link>
            <span className="text-gray-700">|</span>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="text-gray-500 hover:text-accent-blue underline transition-colors whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
